// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolWorkspaceId } from './BrewcontrolWorkspace';
import { brewcontrolNodeId } from './BrewcontrolNode';
import { z } from 'zod';
export const brewcontrolEventId = (z.string());
export const brewcontrolEvent = z.object({
    id: brewcontrolEventId,
    workspace_id: brewcontrolWorkspaceId.nullable(),
    seq: z.string(),
    occurred_at: z.date(),
    bc_run_id: z.string().nullable(),
    intent_id: z.string().nullable(),
    origin: z.string(),
    change_kind: z.string(),
    step_name: z.string().nullable(),
    rejection: z.string().nullable(),
    change: z.unknown(),
    ingested_at: z.date(),
    node_id: brewcontrolNodeId,
});
export const brewcontrolEventInitializer = z.object({
    id: brewcontrolEventId.optional(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    seq: z.string(),
    occurred_at: z.date(),
    bc_run_id: z.string().optional().nullable(),
    intent_id: z.string().optional().nullable(),
    origin: z.string().optional(),
    change_kind: z.string(),
    step_name: z.string().optional().nullable(),
    rejection: z.string().optional().nullable(),
    change: z.unknown(),
    ingested_at: z.date().optional(),
    node_id: brewcontrolNodeId,
});
export const brewcontrolEventMutator = z.object({
    id: brewcontrolEventId.optional(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    seq: z.string().optional(),
    occurred_at: z.date().optional(),
    bc_run_id: z.string().optional().nullable(),
    intent_id: z.string().optional().nullable(),
    origin: z.string().optional(),
    change_kind: z.string().optional(),
    step_name: z.string().optional().nullable(),
    rejection: z.string().optional().nullable(),
    change: z.unknown().optional(),
    ingested_at: z.date().optional(),
    node_id: brewcontrolNodeId.optional(),
});
//# sourceMappingURL=BrewcontrolEvent.js.map